import { render, staticRenderFns } from "./NavigateMainButton.vue?vue&type=template&id=e6141422&"
import script from "./NavigateMainButton.vue?vue&type=script&lang=js&"
export * from "./NavigateMainButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports